import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/fleet-portal/claims')({
    staticData: {
        breadcrumb: {
            title: 'All claims',
        },
    },
    component: Outlet,
});
